import { jsx as _jsx } from "react/jsx-runtime";
import { QueryClientProvider, QueryClient, Hydrate } from '@tanstack/react-query';
import { DefaultProviders, isServer } from '@phishtool/ui';
import { queryClient } from '../service/utils';
const Providers = ({ children, staticData, query }) => {
    const queryClientToUse = isServer ? new QueryClient() : queryClient;
    return (_jsx(QueryClientProvider, Object.assign({ client: queryClientToUse }, { children: _jsx(Hydrate, Object.assign({ state: query }, { children: _jsx(DefaultProviders, Object.assign({ staticData: staticData }, { children: children })) })) })));
};
export default Providers;
